export const endpoint = {
  base: {
    enum: "/enum",
    city_state: "/state-cities",
    send_otp: "/otp",
    verify_otp: "/otp/verify",
  },
  institute: {
    enum: "/enum",
    verify_institute: "/verify",
  },
  account: {
    verify_user: "/auth/verify/user"
  }
};
